<template>
  <div>
    <div>
      <div class="mb-5 flex justify-center text-3xl lg:text-5xl">{{ props.props.label }}</div>
    </div>

    <FlickingVue :options="{
      bound: true,
      align: 'prev',
      preventDefaultOnDrag: true,
      renderOnlyVisible: false,
    }" :plugins="plugins">
      <template v-for="item in props.props.items" :key="item">
        <BookCardVue :item="item"
        @image_touched="emit('image_touched', item)"
            @to_basket="emit('to_basket', item)"
        :mode="'swipe'"
        :loading="props.loading"
        > </BookCardVue>
      </template>

      <template #viewport>
        <span class="flicking-arrow-prev"></span>
        <span class="flicking-arrow-next"></span>
      </template>
    </FlickingVue>
  </div>
</template>
<script lang="ts" setup>
import FlickingVue from '@egjs/vue3-flicking'
import BookCardVue from '@/components/BookCard.vue'
import { Arrow } from "@egjs/flicking-plugins";
import type { BasicCarouselProps, BookItem } from '@/types/book_item'
const props = defineProps<{ props: BasicCarouselProps; loading?: boolean }>()

const plugins = [new Arrow()]
const emit = defineEmits<{
  (e: 'to_basket', item: BookItem): void
  (e: 'in_basket', item: BookItem): void
  (e: 'image_touched', item: BookItem): void
}>()

</script>
